import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { api, errMsg } from "../../lib/api";
import { useApp } from "../../context/AppContext";
import { Field, btnGold, btnGhost } from "../../components/store/ui";

function Shell({ title, children }) {
  return <section className="max-w-md mx-auto px-5 py-16"><h1 className="text-4xl font-extrabold tracking-tight mb-10">{title}</h1>{children}</section>;
}

function GoogleButton() {
  // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
  const go = () => {
    const redirectUrl = window.location.origin + "/account";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };
  return <button type="button" data-testid="google-login-button" onClick={go} className={`${btnGhost} w-full`}>Continuer avec Google</button>;
}

function useAuthSubmit(path) {
  const { onLogin } = useApp();
  const nav = useNavigate();
  const [sp] = useSearchParams();
  const [busy, setBusy] = useState(false);
  const submit = async (body) => {
    setBusy(true);
    try {
      const { data } = await api.post(path, body);
      await onLogin(data);
      nav(sp.get("next") || (["owner", "admin"].includes(data.role) ? "/admin" : "/account"));
    } catch (e) { toast.error(errMsg(e)); }
    setBusy(false);
  };
  return [submit, busy];
}

export function Login() {
  const [f, setF] = useState({ email: "", password: "" });
  const [submit, busy] = useAuthSubmit("/auth/login");
  const [sp] = useSearchParams();
  return (
    <Shell title="Connexion">
      <form className="space-y-5" onSubmit={(e) => { e.preventDefault(); submit(f); }}>
        <Field label="Courriel ou téléphone" testid="login-email" type="text" autoComplete="username" required value={f.email} onChange={(e) => setF({ ...f, email: e.target.value })} />
        <Field label="Mot de passe" testid="login-password" type="password" required value={f.password} onChange={(e) => setF({ ...f, password: e.target.value })} />
        <button data-testid="login-submit" disabled={busy} className={`${btnGold} w-full`}>Se connecter</button>
        <GoogleButton />
        <div className="flex justify-between text-sm text-muted-foreground">
          <Link to={`/register${sp.get("next") ? `?next=${sp.get("next")}` : ""}`} data-testid="link-register">Créer un compte</Link>
          <Link to="/forgot-password" data-testid="link-forgot">Mot de passe oublié</Link>
        </div>
      </form>
    </Shell>
  );
}

export function Register() {
  const [f, setF] = useState({ name: "", email: "", password: "" });
  const [submit, busy] = useAuthSubmit("/auth/register");
  return (
    <Shell title="Créer un compte">
      <form className="space-y-5" onSubmit={(e) => { e.preventDefault(); submit(f); }}>
        <Field label="Nom" testid="register-name" required value={f.name} onChange={(e) => setF({ ...f, name: e.target.value })} />
        <Field label="Email" testid="register-email" type="email" required value={f.email} onChange={(e) => setF({ ...f, email: e.target.value })} />
        <Field label="Mot de passe (8 caractères min.)" testid="register-password" type="password" minLength={8} required value={f.password} onChange={(e) => setF({ ...f, password: e.target.value })} />
        <button data-testid="register-submit" disabled={busy} className={`${btnGold} w-full`}>Créer mon compte</button>
        <GoogleButton />
      </form>
    </Shell>
  );
}

export function Forgot() {
  const [email, setEmail] = useState("");
  const [msg, setMsg] = useState("");
  const send = async (e) => {
    e.preventDefault();
    try { const { data } = await api.post("/auth/forgot-password", { email }); setMsg(data.message); } catch (er) { toast.error(errMsg(er)); }
  };
  return (
    <Shell title="Mot de passe oublié">
      <form className="space-y-5" onSubmit={send}>
        <Field label="Email" testid="forgot-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} />
        <button data-testid="forgot-submit" className={`${btnGold} w-full`}>Envoyer le lien</button>
        {msg && <p className="text-sm text-muted-foreground" data-testid="forgot-message">{msg}</p>}
      </form>
    </Shell>
  );
}

export function Reset() {
  const [sp] = useSearchParams();
  const nav = useNavigate();
  const [password, setPassword] = useState("");
  const send = async (e) => {
    e.preventDefault();
    try { await api.post("/auth/reset-password", { token: sp.get("token"), password }); toast.success("Mot de passe mis à jour"); nav("/login"); } catch (er) { toast.error(errMsg(er)); }
  };
  return (
    <Shell title="Nouveau mot de passe">
      <form className="space-y-5" onSubmit={send}>
        <Field label="Nouveau mot de passe" testid="reset-password" type="password" minLength={8} required value={password} onChange={(e) => setPassword(e.target.value)} />
        <button data-testid="reset-submit" className={`${btnGold} w-full`}>Mettre à jour</button>
      </form>
    </Shell>
  );
}
